import React, { useState, useRef } from "react";
import { TextField, Button, Typography, Box } from "@mui/material";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  verifyOtp,
  sendOtp,
  checkoutToStripePage,
} from "../../apiServices/services/CheckoutServices";
import RiseFormationsLogo from "../../assets/logo/riseformations-logo.webp";
import { useNavigate } from "react-router-dom";

const VerificationCodeForm = ({ handlePrevious, formData }) => {
  const [verificationCode, setVerificationCode] = useState(["", "", "", ""]);

  const inputRefs = useRef([]);

  const [error, setError] = useState(false);
  const [resent, setResent] = useState(false);

  const navigate = useNavigate();

  const handleChange = (index, value) => {
    const newCode = [...verificationCode];
    newCode[index] = value;
    setVerificationCode(newCode);

    if (value && index < 3) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleResend = () => {
    sendOtp({
      mobileNumber: formData.phoneNumber,
      additionalDetails: "Some additional information if needed",
    }).then(() => {
      setResent(true);
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const otp = verificationCode.join("");
    const data = {
      mobileNumber: formData.phoneNumber,
      otp,
    };

    if (!otp) {
      alert("Please enter the Verification Code.");
      return;
    }

    verifyOtp(data).then((res) => {
      if (res.status === 200) {
        console.log(res);
        checkoutToStripePage({ data: formData })
          .then((res) => {
            if (res.status === 200) {
              if (res.data.url !== undefined) {
                window.location.href = res.data.url;
              } else {
                setError(true);
              }
            }
          })
          .catch((err) => console.log("err in checkoutToStripePage : ", err));
      }
    });
  };

  return (
    <Box sx={{ minHeight: "calc(100vh - 6rem)", display: "flex", flexDirection: "column" }}>
      <Box
        sx={{
          width: "100%",
          padding: { xs: "0.75rem 1rem", md: "1rem 2.5rem" },
        }}
      >
        <img
          src={RiseFormationsLogo}
          alt="Rise Formations"
          style={{ height: "1.75rem" }}
        />
      </Box>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: { xs: "1rem", md: "2rem" },
        }}
      >
        <Box sx={{ width: "100%", maxWidth: "448px" }}>
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <Box
              sx={{
                width: "3.5rem",
                height: "3.5rem",
                borderRadius: "0.75rem",
                backgroundColor: "#E8EFFE",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 1rem",
              }}
            >
              <PhoneIphoneIcon sx={{ fontSize: "1.6rem", color: "#1f69f7" }} />
            </Box>
            <Typography
              sx={{
                fontWeight: "700",
                fontSize: "1.875rem",
                color: "#0F0049",
              }}
            >
              Verify your number
            </Typography>
            <Typography
              sx={{
                fontSize: "0.875rem",
                color: "#82808A",
                marginTop: "0.5rem",
              }}
            >
              We've sent a 4-digit code to your phone number. Enter it below
              to continue.
            </Typography>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 3 }}>
            {verificationCode.map((value, index) => (
              <TextField
                key={index}
                inputRef={(el) => (inputRefs.current[index] = el)}
                inputProps={{
                  maxLength: 1,
                  style: { textAlign: "center", fontSize: "1.5rem", fontWeight: 700 },
                }}
                variant="outlined"
                value={value}
                onChange={(e) => handleChange(index, e.target.value)}
                sx={{
                  width: 64,
                  "& .MuiOutlinedInput-root": {
                    height: 64,
                    borderRadius: "8px",
                    backgroundColor: "#fff",
                  },
                }}
              />
            ))}
          </Box>

          <Box sx={{ textAlign: "center", mb: 3 }}>
            <Typography sx={{ fontSize: "0.875rem", color: "#82808A" }}>
              Didn't receive a code?{" "}
              <Box
                component="span"
                onClick={handleResend}
                sx={{
                  color: "#1f69f7",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                {resent ? "Code sent" : "Resend code"}
              </Box>
            </Typography>
          </Box>

          {error && (
            <Box sx={{ textAlign: "center", mb: 2 }}>
              <Typography sx={{ fontSize: "1rem", color: "red" }}>
                An account using that email address already exists.
              </Typography>
              <Button
                type="button"
                sx={{
                  color: "white",
                  backgroundColor: "#181e54",
                  borderRadius: "20px",
                  fontSize: "0.8rem",
                  fontWeight: "bold",
                  textTransform: "none",
                  paddingX: "1.1rem",
                  marginTop: "0.5rem",
                }}
                onClick={() => {
                  navigate("/login");
                }}
              >
                Please login here.
              </Button>
            </Box>
          )}

          {!error && (
            <Button
              type="submit"
              fullWidth
              sx={{
                color: "white",
                backgroundColor: "#1f69f7",
                borderRadius: "8px",
                padding: "0.75rem 1rem",
                fontSize: "0.875rem",
                fontWeight: "600",
                textTransform: "none",
                ":hover": {
                  backgroundColor: "#1859c6",
                },
              }}
            >
              Verify & Continue
            </Button>
          )}

          <Box sx={{ textAlign: "center", mt: 2 }}>
            <Box
              onClick={handlePrevious}
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: "0.25rem",
                fontSize: "0.875rem",
                color: "#82808A",
                cursor: "pointer",
              }}
            >
              <ArrowBackIcon sx={{ fontSize: "1rem" }} />
              Back to sign up
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default VerificationCodeForm;
